import React from "react";
//#region types
import { GenericDocumentVouchersProps } from "models/propTypes/documentPropTypes";
//#endregion
//#region components
import { Vouchers } from "components/voucher";
import { useGenericDocumentService } from "serviceHooks";

//#endregion

const GenericDocumentVouchers: React.FC<GenericDocumentVouchersProps> = (props) => {
  const genericDocumentService = useGenericDocumentService();
  return <Vouchers parentId={props.id} getVouchersHandler={genericDocumentService.getTransactions} />;
};

export default GenericDocumentVouchers;
